import React, { FC } from 'react'
import { Route, Routes } from 'react-router-dom'

import { useAppSelector } from '@hooks/redux'
import { getRoutesList } from '@utils/utils'

import { Page404 } from '@views/misc'

import { IRenderRoutesProps as IProps } from './types'
import Page403 from '@app/views/misc/components/Page403'

const RenderRoutes: FC<IProps> = ({ routes }) => {
  const routeslist = getRoutesList(routes)

  const { isError403, isError404 } = useAppSelector((state) => state.utils)

  return (
    <Routes>
      {!isError403 && !isError404 && routeslist}
      {isError403 && <Route path='*' element={<Page403 />}/>}
      <Route path='*' element={<Page404 />}/>
    </Routes>
  )
}

export default RenderRoutes
